<template>
  <span
    v-if="disableTransitions"
    :class="containerKls"
    :style="{ backgroundColor: color, color: fontColor }"
    @click="handleClick"
  >
    <span :class="ns.e('content')">
      <slot />
    </span>
    <lt-icon v-if="closable" :class="ns.e('close')" @click.stop="handleClose">
      <Close />
    </lt-icon>
  </span>
  <transition
    v-else
    :name="`${ns.namespace.value}-zoom-in-center`"
    appear
    @vue:mounted="handleVNodeMounted"
  >
    <span
      :class="containerKls"
      :style="{ backgroundColor: color, color: fontColor }"
      @click="handleClick"
    >
      <span :class="ns.e('content')">
        <slot />
      </span>
      <lt-icon v-if="closable" :class="ns.e('close')" @click.stop="handleClose">
        <Close />
      </lt-icon>
    </span>
  </transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import LtIcon from '@lit-element/components/icon'
import { useNamespace } from '@lit-element/hooks'
import { useFormSize } from '@lit-element/components/form'
import { Close } from '@inte-cloud/icons-vue'

import { tagEmits, tagProps } from './tag'
import type { VNode } from 'vue'

defineOptions({
  name: 'LtTag',
})
const props = defineProps(tagProps)
const emit = defineEmits(tagEmits)

const tagSize = useFormSize()
const ns = useNamespace('tag')
const containerKls = computed(() => {
  const { type, hit, effect, closable, round } = props
  return [
    ns.b(),
    ns.is('closable', closable),
    ns.m(type || 'primary'),
    ns.m(tagSize.value),
    ns.m(effect),
    ns.is('hit', hit),
    ns.is('round', round),
  ]
})

// methods
const handleClose = (event: MouseEvent) => {
  emit('close', event)
}

const handleClick = (event: MouseEvent) => {
  emit('click', event)
}

const handleVNodeMounted = (vnode: VNode) => {
  // @ts-ignore
  vnode.component.subTree.component.bum = null
}
</script>
